import React from 'react'
import Typography from "@mui/material/Typography";
import BookLayout from '../../layout/Books';

const Books = () => {
  return (
    <div className="mainDiv">
         <Typography className="heading">Books</Typography>
         <BookLayout />
         </div>
  )
}

export default Books
